/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriageResult } from './TriageResult';
import {
    TriageResultFromJSON,
    TriageResultFromJSONTyped,
    TriageResultToJSON,
    TriageResultToJSONTyped,
} from './TriageResult';
import type { CaptureAnnotation } from './CaptureAnnotation';
import {
    CaptureAnnotationFromJSON,
    CaptureAnnotationFromJSONTyped,
    CaptureAnnotationToJSON,
    CaptureAnnotationToJSONTyped,
} from './CaptureAnnotation';

/**
 * 
 * @export
 * @interface CaptureAnnotationItem
 */
export interface CaptureAnnotationItem {
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    triageResult?: TriageResult | null;
    /**
     * 
     */
    annotation?: CaptureAnnotation | null;
}



/**
 * Check if a given object implements the CaptureAnnotationItem interface.
 */
export function instanceOfCaptureAnnotationItem(value: object): value is CaptureAnnotationItem {
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    return true;
}

export function CaptureAnnotationItemFromJSON(json: any): CaptureAnnotationItem {
    return CaptureAnnotationItemFromJSONTyped(json, false);
}

export function CaptureAnnotationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureAnnotationItem {
    if (json == null) {
        return json;
    }
    return {
        
        'captureId': json['capture_id'],
        'triageResult': json['triage_result'] === undefined ? undefined : json['triage_result'] === null ? null : TriageResultFromJSON(json['triage_result']),
        'annotation': json['annotation'] === undefined ? undefined : json['annotation'] === null ? null : CaptureAnnotationFromJSON(json['annotation']),
    };
}

export function CaptureAnnotationItemToJSON(json: any): CaptureAnnotationItem {
    return CaptureAnnotationItemToJSONTyped(json, false);
}

export function CaptureAnnotationItemToJSONTyped(value?: CaptureAnnotationItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_id': value['captureId'],
        'triage_result': TriageResultToJSON(value['triageResult']),
        'annotation': CaptureAnnotationToJSON(value['annotation']),
    };
}

